export default "__VITE_ASSET__CoXXXF6b__"